import SyncView from './SyncView';
import PyWebVue from './PyWebVue';

export default {
  SyncView,
  PyWebVue,
};
